import groq from "groq";

export const TRUSTED_HOME_LOCAL_PAGE_QUERY = groq`
*[_type == "trusted-home-care-local-page" && urlSlug.current == $slugParam][0]{
  title,
  subtitle,
  description,
  urlSlug,
  "franchise": franchise-> {
    _type,
    _id,
    _createdAt,
    _updatedAt,
    _rev,
    phoneNumber,
    franchiseRating,
   franchiseAreas[],
   id,
   location {
      _type,
      _id,
      _createdAt,
      _updatedAt,
      _rev,
     name,
     postalCode,
     city,
     stateProvince,
     addressLine1,
     addressLine2,
   },
   phoneNumber,
   reviewCarouselTitle,
   reviews[],
    franchiseHomeCareServices {
      homeCareServicesTitle,
      "displayedServicesList": homeCareServices[isDisplayed == true && defined(service)]{
        service->{
          _id,
          serviceName,
          description,
          icon {
            asset->{
              _id,
              url,
              metadata {
                  dimensions
              }
            }
          }
        }
      }[defined(service)]
    },
  },
  consultationSectionTitle,
  consultationSectionSubtitle,
  consultationButtonText,
  benefitsSectionTitle,
  benefitsSectionSubtitle,
  benefitsList[]{ 
    _key,
    title,
    content,
    icon { 
      asset->{ 
        _id,
        url,
        metadata { 
            dimensions
        }
      }
    }
  },
  testimonialsSectionTitle,
  testimonialsList[]{ 
    _key,
    name,
    text
  },
  contactUsSection {
    title,
    body,
    callUsText,
    areasSubtitle,
    mapImage {
      asset->{
        _id,
        url,
        metadata {
            dimensions
        }
      },
      alt
    }
  }
}
`;
